import { ModalComponent } from '../../shared/modal/modal.component';
import { Empty } from '../../../models/utils.model';
import { Answer, Modal, Question } from '../../../models/qa.model';
import { Subscription } from 'rxjs/Rx';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { VisualizerService } from '../../../services/visualizer.service';
import { StartupService } from '../../../services/startup.service';
import { ColorGroup, ProjectImage, VisualizerResponse, VisualizerStateReady } from '../../../models/color.model';
import { QaService } from '../../../services/qa.service';
import { QuestionTypeEnum } from '../../../models/question-type';
import { HistoryService } from '../../../services/history.service';
import { Router } from '@angular/router';
import { OpacityConstants } from '../../../models/opacity-constants.enum';
import { trigger, state, style, animate, transition, group, query, stagger } from '@angular/animations';
import { AnswerInfoService } from '../../../services/answer-info.service';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-visualizer',
  templateUrl: './visualizer.component.html',
  styleUrls: ['./visualizer.component.scss'],
  animations: [
    trigger('visualizerAnimate', [
      state('in', style({ opacity: 1 })),
      state('out', style({ opacity: 0 })),
      transition('out => in', [
        animate('600ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class VisualizerComponent implements OnInit, OnDestroy {
  @ViewChild('errorModal') modalComponent: ModalComponent;

  public modal: Modal = new Modal({
    Title: 'Oops',
    Text: 'Sorry, there is no photo for specified project, please start again or change answers.',
    ButtonText: 'Back',
    ButtonClickFunction: () => { this.historyService.back(); },
    Button2Text: 'Start again',
    Button2ClickFunction: () => { window.location.href = '/'; },
    HideModal: true
  });


  visualizerState: VisualizerStateReady;
  visualizerStateSubscription: Subscription;
  visualizerDataSubscription: Subscription;
  subscription: Subscription;
  colorGroups: ColorGroup[];
  projectImages: ProjectImage[];
  loadVisualizerAnimation: string = 'out';

  constructor(
    private router: Router,
    public visualizerService: VisualizerService,
    private qaService: QaService,
    private startupService: StartupService,
    private historyService: HistoryService,
    private answerInfoService: AnswerInfoService,
    private metaService: MetaService
  ) { }

  ngOnInit() {
    this.historyService.next(this.router.url, this.qaService.answers);
    this.getOpacities();
    this.visualizerStateSubscription = this.visualizerService.isReady.subscribe(vState => {
      this.visualizerState = vState;
    });

    this.qaService.updateProgress('90');

    /* let opacities = ['d6828d21-e4f1-4829-9a23-b59b1495736d', '8a3de9d1-8b66-4e25-8008-546e136cb308',
    'AD0B4872-3946-4C72-BFDD-0A68C23E1EDE',
  '3D94A58E-CE3A-474B-B6B3-D8949D03433A', 'E1B0AA19-0A10-42B2-A6E8-E3ED35E6118F', '665FFBB8-E055-4498-B684-9565BD1E1D4E',
  '3F4CC1B4-98BD-4818-BF26-B290ED2DB1A3'];*/
    const opacities = this.getOpacities();
    const projectId = this.answerInfoService.getSelectedProject(); // 'DA4F8CF4-6F96-41B2-8292-9A1D6A1A4A2D'; //
    const woodGrainId = this.answerInfoService.getSelectedWoodGrain(); // 'D3C7511B-8856-4D73-BCDF-02BCB63D4BF4'; //
    const woodTypeId = this.answerInfoService.getSelectedWoodType();
    this.visualizerDataSubscription = this.visualizerService.getVisualizerData(opacities, projectId, woodGrainId, woodTypeId)
      .subscribe((data) => {
        if (data.ColorGroups === null || data.ProjectImages === null) {
          this.modalComponent.modal.HideModal = false;
          return;
        }

        this.visualizerService.visualizerData = data;
        // console.log(this.visualizerService.visualizerData);

        this.visualizerState.DataIsReady = true;
      },
        (e) => console.log('Data problem.', e)
      );

    this.metaService.setMetaTags('Visualize your project', '', '');
  }

  private getOpacities(): Array<string> {
    const array: Array<string> = new Array();
    const lastAnswer = this.GetLastOpacityFilter(this.qaService.answers.selectedAnswers);
    const projectType = this.qaService.getProject();
    if (lastAnswer !== null) {
      const opacityArray = lastAnswer.split(';');
      for (const opacity of opacityArray) {
        // avoid duplicates
        if (array.indexOf(opacity) === -1) {
          if (opacity === '3f4cc1b4-98bd-4818-bf26-b290ed2db1a3') {
            // if (projectType === 'deck') { // Not sure what this was for. I'll probably regret commenting it - j.dillon
              array.push(opacity);
            // }
          } else {
            array.push(opacity);
          }
        }
      }
      if (projectType === 'deck' && this.answerInfoService.getSelectedWoodGrain() !== '877b5a5e-f292-4be1-bb75-fb0e9634b3b5') {
        if (array.indexOf(OpacityConstants.Resurfacer) === -1) {
          array.push(OpacityConstants.Resurfacer);
        }
      }
    }
    return array;
  }

  private GetLastOpacityFilter(answers: Answer[]): string {
    for (let i = answers.length - 1; i >= 0; i--) {
      if (
        answers[i].QuestionType !== this.answerInfoService.getQuestionTypeGuid(QuestionTypeEnum.ProductQuality) &&
        answers[i].OpacityFilter.indexOf(OpacityConstants.CurrentOpacity) < 0
      ) {
        return answers[i].OpacityFilter;
      }
    }
    return null;
  }

  ngOnDestroy() {
    // this.visualizerService.visualizerData = null;
    this.visualizerStateSubscription.unsubscribe();
    this.visualizerDataSubscription.unsubscribe();
  }

  onLoaderComplete(vState: string): void {
    this.loadVisualizerAnimation = vState;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizer/visualizer/visualizer.component.ts